
/* injects from baggage-loader */

import AlertModule from './alert/alert.module';
import FeedbackModule from './feedback/feedback.module';
import MatemagicoModule from './matemagico/matemagico.module';
import MissionModule from './mission/mission.module';
import TutorialModule from './tutorial/tutorial.module';
//import MenuModule from './menu/menu.module';
//import DialogTrophiesModule from './trophies/trophies.module';
//import IntroModule from './intro/intro.module';
//import ImageModule from './image/image.module.js';

const shared = angular.module('dialog-module', [
	AlertModule.name,
	FeedbackModule.name,
	MissionModule.name,
	TutorialModule.name,
	MatemagicoModule.name,
	//MenuModule.name,
	//DialogTrophiesModule.name,
	//IntroModule.name,
	//ImageModule.name
]);

export default shared;


// WEBPACK FOOTER //
// ./src/app/components/dialogs/dialogs.module.js